export const getMetricFieldPrecision = <TField extends keyof UnitPerField>(
  field: TField | undefined,
  unit: UnitPerField[TField],
  type?: string | null,
  sensor?: string | null,
) => {
  if (!field) return 1;
  if (!(field in precisionPerField)) return 1;
  const fieldPrecisions = precisionPerField[field](type, sensor);
  if (!(unit in fieldPrecisions)) return 1;
  return fieldPrecisions[unit];
};

export type UnitPerField = {
  flow: 'liter-per-second' | 'cubic-meter-per-second' | 'cubic-meter-per-hour';
  level: 'meter' | 'centimeter';
  volume: 'cubic-meter';
  position: 'centimeter';
  velocity: 'millimeter-per-second';
  angle: 'degree';
  concentration: 'percent';
  current: 'ampere';
  power: 'watt';
  voltage: 'volt';
  ph: 'ph';
  orp: 'millivolt';
  turbidity: 'ntu' | 'fnu';
  temperature: 'celsius';
  conductivity: 'millisiemens-per-centimeter';
};

const precisionPerField: {
  [TField in keyof UnitPerField]: (
    type?: string | null,
    sensor?: string | null,
  ) => Record<UnitPerField[TField], number>;
} = {
  flow: () => {
    return {
      'liter-per-second': 1,
      'cubic-meter-per-second': 2,
      'cubic-meter-per-hour': 1,
    };
  },
  level: (_, sensor) => {
    if (sensor === 'L' || sensor === 'LG' || sensor === 'LV') {
      return {
        meter: 2,
        centimeter: 1,
      };
    }
    if (sensor === 'LF' || sensor === 'F') {
      return {
        meter: 2,
        centimeter: 0,
      };
    }
    return {
      meter: 1,
      centimeter: 0,
    };
  },
  volume: (_, sensor) => {
    if (sensor === 'LF' || sensor === 'F' || sensor === 'LV') {
      return {
        'cubic-meter': 0,
      };
    }
    return {
      'cubic-meter': 1,
    };
  },

  position: () => {
    return {
      centimeter: 1,
    };
  },
  velocity: () => {
    return {
      'millimeter-per-second': 1,
    };
  },
  angle: () => {
    return {
      degree: 1,
    };
  },
  concentration: () => {
    return {
      percent: 1,
    };
  },
  current: () => {
    return {
      ampere: 1,
    };
  },
  power: () => {
    return {
      watt: 1,
    };
  },
  voltage: () => {
    return {
      volt: 1,
    };
  },
  ph: () => {
    return {
      ph: 1,
    };
  },
  orp: () => {
    return {
      millivolt: 1,
    };
  },
  turbidity: () => {
    return {
      ntu: 1,
      fnu: 1,
    };
  },
  temperature: () => {
    return {
      celsius: 1,
    };
  },
  conductivity: () => {
    return {
      'millisiemens-per-centimeter': 2,
    };
  },
};
